import {Marker} from "../../complex-delivery-view/markers/marker";

export class DisplayedMarker {
  constructor(public id: number, public marker: Marker) {
  }
}
